module.exports = "https://www.gc-pro.gnp.com.mx/12a2cbe78e39439da030acba78bbfaa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-video-12.png
// module id = 939
// module chunks = 0 1